import React, { useRef, useEffect, useState } from 'react';
import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';

function LottiePlayer({className, id, src, frames, visibility, interactivity=true, style, actions = []}) {
  const lottieRef = useRef();
  useEffect(() => {
    if (interactivity) {
      lottieRef.current.addEventListener('load', () => {
        create({
          mode:"scroll",
          player: `#${id}`,
          // actions: [
          // {
          //     visibility: visibility,
          //     type: "seek",
          //     frames: frames,
          // },
          // ]
          actions: actions
        });
      });  
    }
  }, [lottieRef]);
  if (interactivity) {
    return (
      <lottie-player ref={lottieRef} class={className} id={id} src={src} style={style}></lottie-player>
   )
  } else {
    return (
      <lottie-player ref={lottieRef} class={className} id={id} src={src} style={style} loop={true} autoplay={true}></lottie-player>
   )
  }

}

export default LottiePlayer
